<template>
  <div class="page-shell page-shell--enterprise-app">
    <section class="page-shell__content">
      <div class="page-shell__panel">
        <div class="page-shell__panel-header">
          <div>
            <div class="page-shell__panel-title">应用列表</div>
            <div class="page-shell__panel-subtitle">
              通过名称、服务商和状态快速定位当前企业应用。
            </div>
          </div>
        </div>
        <public-table
          :loading="Loading"
          :column="column"
          :searchItems="searchItems"
          :enableSearch="true"
          :tableData="appList"
          :PageInfo="listQuery"
          @handlePaginationChange="handleSearchList"
        >
          <template v-slot:expiredTime="{ row }">
            <span>{{
              row.expiredTime ? timetrans(row.expiredTime) : "-"
            }}</span>
          </template>

          <template v-slot:createTime="{ row }">
            <span>{{ row.createTime ? timetrans(row.createTime) : "-" }}</span>
          </template>

          <template v-slot:appStatus="{ row }">
            <span
              :style="{
                color: fetchAppState(row.appStatus, true),
              }"
            >
              {{ fetchAppState(row.appStatus) }}
            </span>
          </template>
          <template v-slot:operation="{ row }">
            <el-button v-permit="'DeliveryApp.Get'" size="mini" type="text" @click="handleEditSort(row)">
              详情
            </el-button>
          </template>
        </public-table>
      </div>
    </section>
  </div>
</template>
<script>
const defaultListQuery = {
  query: '',
  page: 1,
  pageSize: 10,
  total: 1
};
import { fetchAppState, fetchEnterpriseAppStateOptions } from '@/utils/dictionary';
import { timetrans } from '@/utils/validate';
export default {
  name: 'Appinfo',
  computed: {
    activeFilterCount() {
      return ['appName', 'marketID', 'status'].filter((key) => {
        return this.listQuery[key];
      }).length;
    }
  },
  data() {
    return {
      dialogVisible: false,
      fetchAppState,
      listQuery: defaultListQuery,
      Loading: false,
      appList: [],
      activeNumber: 0,
      timetrans,
      searchItems: [
        {
          name: 'appName',
          label: '应用',
          value: '',
          span: 7,
          type: 'input'
        },
        {
          name: 'marketID',
          label: '服务商',
          type: 'select',
          span: 7,
          options: []
        },
        {
          name: 'status',
          label: '应用状态',
          type: 'select',
          span: 7,
          options: fetchEnterpriseAppStateOptions()
        }
      ],
      column: [
        {
          prop: 'appName',
          label: '应用'
        },
        {
          prop: 'appVersion',
          label: '版本'
        },
        {
          prop: 'comboName',
          label: '套餐'
        },
        {
          prop: 'marketName',
          label: '服务商'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'expiredTime',
          label: '到期时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'appStatus',
          label: '应用状态',
          width: '100px',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '100px',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.getEnteriseAppList();
    this.getEnteriseAppServiceList();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    handleEditSort(row) {
      this.$router.push({
        name: 'enterpriseAppDetails',
        params: {
          appId: row.appID
        }
      });
    },
    handleSearchList(parameter) {
      if (parameter) {
        this.listQuery = Object.assign({}, this.listQuery, parameter);
      } else {
        this.listQuery.page = 1;
      }
      this.getEnteriseAppList();
    },
    getEnteriseAppList(parameter) {
      if (parameter) {
        this.listQuery = Object.assign(this.listQuery, parameter);
      }
      if (this.listQuery.appName) {
        this.listQuery.appName = this.listQuery.appName.trim();
      }
      this.listQuery.tag = JSON.stringify(this.listQuery.tag);
      this.Loading = true;
      this.$store
        .dispatch('getEnteriseAppList', this.listQuery)
        .then((res) => {
          if (res) {
            this.appList = res.apps;
            this.listQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    getEnteriseAppServiceList() {
      this.$store
        .dispatch('getEnteriseAppServiceList')
        .then((res) => {
          if (res) {
            const arr = [
              {
                label: '全部',
                value: ''
              }
            ];
            if (res && res.markets && res.markets.length > 0) {
              res.markets.map((item) => {
                const { marketID, name } = item;
                arr.push({
                  label: name,
                  value: marketID
                });
              });
            }
            this.searchItems[1].options = arr;
          }
          this.Loading = false;
        })
        .catch(() => {
          this.Loading = false;
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/enterpriseApp/index.vue